// 專案管理服務
import { db } from '../cloudsql';

export interface Project {
  id: string;
  customer_id: string;
  name: string;
  status?: 'not_started' | 'active' | 'on_hold' | 'completed'; // 專案狀態：尚未開始、進行中、暫停中、已完成
  budget?: number;
  budget_type?: 'unlimited' | 'quote_sum' | 'fixed';
  selected_quote_ids?: string[];
  contact_ids?: string[];
  primary_contact_id?: string;
  invoice_contact_id?: string; // 發票聯絡人
  partner_ids?: string[];
  contract_id?: string;
  billing_mode?: 'per_project' | 'consolidated';
  primary_pm_id?: string; // 主要PM ID
  primary_pm_type?: 'partner' | 'operator'; // 主要PM類型
  last_deploy_version?: string; // 最後一個上版編號（從專案項目中自動更新）
  created_at: string;
  updated_at: string;
}

export class ProjectsService {
  // 取得所有專案
  async getAll(orderBy?: { field: string; direction: 'asc' | 'desc' }[]): Promise<Project[]> {
    return db.query<Project>('projects', {
      orderBy: orderBy || [{ field: 'created_at', direction: 'desc' }]
    });
  }

  // 依客戶 ID 取得專案
  async getByCustomerId(customerId: string): Promise<Project[]> {
    return db.query<Project>('projects', {
      where: { customer_id: customerId },
      orderBy: [{ field: 'created_at', direction: 'desc' }]
    });
  }

  // 依 ID 取得專案
  async getById(id: string): Promise<Project | null> {
    return db.getById<Project>('projects', id);
  }

  // 依狀態取得專案
  async getByStatus(status: string): Promise<Project[]> {
    return db.query<Project>('projects', {
      where: { status },
      orderBy: [{ field: 'created_at', direction: 'desc' }]
    });
  }

  // 建立專案
  async create(data: Omit<Project, 'id' | 'created_at' | 'updated_at'>): Promise<Project> {
    return db.create<Project>('projects', data);
  }

  // 更新專案
  async update(id: string, data: Partial<Project>): Promise<Project> {
    return db.update<Project>('projects', id, data);
  }

  // 刪除專案
  async delete(id: string): Promise<void> {
    return db.delete('projects', id);
  }

  // 批次取得專案（依 ID 陣列）
  async getByIds(ids: string[]): Promise<Project[]> {
    if (ids.length === 0) return [];
    return db.query<Project>('projects', {
      where: { id: ids }
    });
  }
}

// 匯出單例
export const projectsService = new ProjectsService();


